import { DefaultFooter } from '@ant-design/pro-components';
import { useModel } from '@umijs/max';
import React from 'react';
import { DEFAULT_GENERAL_SETTINGS } from '@/utils/generalSettings';

const Footer: React.FC = () => {
  const { initialState } = useModel('@@initialState');
  const generalSettings =
    initialState?.generalSettings || DEFAULT_GENERAL_SETTINGS;

  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright={generalSettings.footerText || '2026 Data Block'}
    />
  );
};

export default Footer;
